// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"f01cd58e","714":"e8c88e8f"}[chunkId] + ".chunk.js";
};